import { Link } from 'react-router-dom';
import { formatPrice } from '../api';
import WishlistButton from './WishlistButton';
import Stars from './Stars';

export default function ProductCard({ product }) {
  return (
    <Link to={`/product/${product.id}`} className="group block">
      <div className="product-img-wrap aspect-[4/5] mb-4 relative">
        <img src={product.image} alt={product.name} className="w-full h-full object-cover" loading="lazy" />
        {product.isNew && (
          <span className="absolute top-4 left-4 bg-[#F4EEE4] text-[10px] tracking-widest-plus uppercase px-2 py-1">New</span>
        )}
        <WishlistButton product={product} className="absolute top-3 right-3 w-9 h-9 rounded-full bg-[#F4EEE4]/90 backdrop-blur hover:bg-[#F4EEE4]" />
      </div>
      <div className="flex flex-col items-start">
        <h3 className="font-serif-display text-lg md:text-xl leading-tight group-hover:text-[#C6410E] transition-colors duration-300">
          {product.name}
        </h3>
        <p className="text-[11px] tracking-widest-plus uppercase text-[#1a1a1a]/50 mt-1">{product.color}</p>
        <div className="flex items-center gap-3 mt-2">
          <p className="text-sm">{formatPrice(product.price)}</p>
          {product.rating_count > 0 && <span className="flex items-center gap-1 text-[11px] text-[#1a1a1a]/60"><Stars value={product.rating_avg} size="w-3 h-3" /> {product.rating_avg.toFixed(1)}</span>}
        </div>
      </div>
    </Link>
  );
}
